import { Divider, Flex, Text } from "@mantine/core";
import DraftAutoSaveModal from "src/components/shared/_Modals/DraftAutoSaveModal/DraftAutoSaveModal";
import { BackButton } from "src/components/shared/BackButton/BackButton";
import { useIsExpired } from "src/generator/hooks/useIsExpired";
import { ReadonlyFieldset } from "src/generator/Logbook/Logbook.styled";
import { useIsNewEntry } from "src/hooks";
import { useSelector } from "src/redux/hooks";

import NewEntryButton from "../_Buttons/NewEntryButton";
import ReopenNMEAModalButton from "../_Buttons/ReopenNMEAModalButton";
import SaveEntryButton from "../_Buttons/SaveEntryButton";
import SearchButton from "../_Buttons/SearchButton";
import SearchRefInput from "../_Buttons/SearchRefInput";
import SortEntriesButton from "../_Buttons/SortEntriesButton";
import GlobalCollapseButton from "../../../components/shared/GlobalCollapseButton/GlobalCollapseButton";
import EntryLockInfo from "../EntryLockInfo/EntryLockInfo";
import EntryText from "../EntryText";
import HamburgerMenu from "../HamburgerMenu/HamburgerMenu";
import LogBarSelects from "../LogBarSelects/LogBarSelects";
import StatusBadge from "../StatusBadge/StatusBadge";

const DefaultLogBar = () => {
  const { latestEntry, lbentry } = useSelector(state => state.generatorSlice);
  const isNewEntry = useIsNewEntry();
  const isExpiredLogbook = useIsExpired();
  const isReadOnly = useSelector(
    state => state.generatorSlice.lbentry.isReadonly,
  );

  return (
    <>
      <Flex
        style={{ justifyContent: "space-between" }}
        m={0}
        align="center"
        direction="row"
        wrap="wrap"
        gap={"20px"}
        mb={15}>
        <Flex direction="column">
          <Flex align={"center"} gap={25} mb={5}>
            <BackButton />
            <Text
              maw={400}
              data-cy="lbname"
              style={{ textTransform: "capitalize" }}>
              {latestEntry.lbName}
            </Text>
            {latestEntry.entryref && (
              <Text maw={400} data-cy="lbentryref">
                Entry Ref. #{latestEntry.entryref}
              </Text>
            )}
            <SearchRefInput />
            <StatusBadge
              status={isNewEntry ? "new" : latestEntry.status}
              autosave={latestEntry.autosave}
            />
            <EntryLockInfo />
          </Flex>
          <EntryText />
          <div style={{ maxWidth: "450px" }}>
            <DraftAutoSaveModal />
          </div>
        </Flex>
        <Flex align={"center"} justify={"flex-end"} wrap="wrap">
          <GlobalCollapseButton />
          <SortEntriesButton />
          <ReopenNMEAModalButton />
          <ReadonlyFieldset disabled={isReadOnly}>
            {!isExpiredLogbook && <SaveEntryButton />}
            {!isExpiredLogbook && !lbentry.continousEntry && <NewEntryButton />}
          </ReadonlyFieldset>
          {!isExpiredLogbook && <SearchButton />}
          <HamburgerMenu />
        </Flex>
      </Flex>
      <LogBarSelects mr={-40} />
      <Divider my="sm" />
    </>
  );
};

export default DefaultLogBar;
